export default __webpack_public_path__ + "static/media/assets-film_04.ea6662ac.jpg";